module.exports = __webpack_public_path__ + "img/operate_data.4ae67c68.png";